var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.showlabel)?_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t('TL_EXPORT_GRANULARITY_BADGE')))])]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.exporthistory.ExportDocumentMode)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }